import { render, staticRenderFns } from "./profileLayout.vue?vue&type=template&id=be3cc7e0&"
import script from "./profileLayout.vue?vue&type=script&lang=js&"
export * from "./profileLayout.vue?vue&type=script&lang=js&"
import style0 from "./profileLayout.vue?vue&type=style&index=0&lang=css&"
import style1 from "./profileLayout.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports